import React, { useState } from "react";
import { Link } from "gatsby";
import Select from "react-dropdown-select";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import "./ValuationInfo.scss";
import BookValuationForm from '../../forms/instant-valuation-form';
const BookaValuationForm = (props) => {
  const Departments = [
    { value: "Option", label: "Option" },
    { value: "Option1", label: "Option1" },
    { value: "Option2", label: "Option2" },
    { value: "Mortgage type", label: "Mortgage type" },
  ];
  const Branch = [
    { value: "Option", label: "Option" },
    { value: "Option1", label: "Option1" },
    { value: "Option2", label: "Option2" },
    { value: "Select branch", label: "Select branch" },
  ];
  return (
    <React.Fragment>
      <section className="valuation-info instant-valuation-wrap">
        <Container>
          <Row>
            <Col>
              
              

                <div className="valuation-box book">
                  <Link className="icons">
                    <i className="home">
                    </i>
                  </Link>
                  <h3 className="val-heading">Instant Property Valuation</h3>
                  <p className="val-heading">If an instant online house valuation is your starting point, then our responsive and constantly updated system is for you. It’s quick and easy to use, and absolutely free.</p>
                  <BookValuationForm postcode_mapping={props.postcode_mapping}/>
                </div>
              
              <div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default BookaValuationForm;
